import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import AddCampusDrive from "../../component/campusDrive/form";
import constant from "../../constant";
import {
    campusDriveById,
    createCampusDrive,
    updateCampusDrive
} from "../../actions/campusDriveAction";

const AddCampusDriveContainer = () => {

    const navigate = useNavigate();
    const params = useParams();

    const [data, setData] = useState(null);
    const [response, setResponse] = useState({});
    const [showMsg, setShowMsg] = useState(false);

    useEffect(() => {
        if (params.id) {
            campusDriveById(params.id).then((res) => {
                debugger
                if (res.status) {
                    setData(res.result);
                } else {
                    setResponse(res);
                    setShowMsg(true);
                }
            });
        }
    }, [params.id]);

    const onSubmit = (model) => {
        const apiCall = model.ID
            ? updateCampusDrive(model)
            : createCampusDrive(model);

        apiCall.then((res) => {
            if (res.status) {
                navigate(constant.component.campusDrive.url);
            } else {
                setResponse(res);
                setShowMsg(true);
                setTimeout(() => setShowMsg(false), 5000);


            }
        });
    };

    return (
        <React.Fragment>
            <AddCampusDrive
                onSubmit={onSubmit}
                detail={data}
                response={response}
                showMsg={showMsg}
            />
        </React.Fragment>
    );
};

export default AddCampusDriveContainer;
